let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("16R8u")]).then(() => parcelRequire('6DbUp'));